import { render } from "./ordentrabajoresultadoprocedimiento.vue?vue&type=template&id=dcb8a6aa&scoped=true"
import script from "./ordentrabajoresultadoprocedimiento.vue?vue&type=script&lang=js"
export * from "./ordentrabajoresultadoprocedimiento.vue?vue&type=script&lang=js"

import "./ordentrabajoresultadoprocedimiento.vue?vue&type=style&index=0&id=dcb8a6aa&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb8a6aa"]])

export default __exports__